<template>
  <v-text-field ref="textField" v-model="inputText" />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputText: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    focus() {
      this.$refs.textField.focus()
    },
  },
}
</script>
<style scoped>
/* 高さ36px margin-top:4px */
.v-input {
  padding: 0 !important;
  margin: 0px;
}
.v-input >>> input {
  padding: 0 !important;
}
.v-input >>> .v-input__slot {
  margin-bottom: 0 !important;
}
.v-input >>> .v-text-field__slot {
  font-size: 14px;
}
.v-input >>> .v-text-field__details {
  height: 0px !important;
}
</style>
